<div id="viewDiv" class="map" [ngClass]="mapLoaded() ? '' : 'notLoaded'">
    <ng-container *ngIf="!waitingForClick()">
        <app-map-header-component/>
        <section *ngIf="mapLoaded()" #mapCustomWidgets class="widget-buttons-container">
            <app-layers-list-widget-visualization [mapview]="view" ></app-layers-list-widget-visualization>
            <app-legend-widget-visualization [mapview]="view" ></app-legend-widget-visualization>
            <app-basemap-gallery-widget-visualization [mapview]="view"></app-basemap-gallery-widget-visualization>
        </section>
        <ng-container *ngIf="isMobile()">
            <img *ngIf="isMobile()" class="concello-mobile-logo" alt="concello-mobile-logo" src="assets/img/logo-concello.png">
            <button  mat-mini-fab (click)="locateButtonClicked()" class="locate-mobile-button">
                <mat-icon fontIcon="my_location"></mat-icon>
            </button>
        </ng-container>
        <div *ngIf="!sidenavOpened()" class="sidenav-arrow-container" (click)="sidenavOpened.set(true)">
            <mat-icon  class="sidenav-arrow-icon">arrow_forward_ios</mat-icon>
        </div>
        <div *ngIf="routeFormResult()" class="details-container" [ngClass]="isMobile() ? 'details-container-smaller': ''" [style.width]="isMobile() ? '100%' : '50%'">
            <div class="detail-arrows-container">
                <div class="arrow-container arrow-up-container" *ngIf="itinerarySelected() && showItineraryDetails() !== 'fullOpen'"
                 (click)="showItineraryDetails.set(showItineraryDetails() === 'closed' ? 'midOpen' : 'fullOpen')"
                 [ngClass]="'arrow-up-container-'+showItineraryDetails()" [style.top]="isMobile() && showItineraryDetails() === 'closed' ? '-100px' : ''">
                    <mat-icon class="details-arrow-up-icon">arrow_forward_ios</mat-icon>
                </div>
                <div class="arrow-container arrow-down-container" *ngIf="itinerarySelected() && showItineraryDetails() !== 'closed'"
                 (click)="showItineraryDetails.set(showItineraryDetails() === 'fullOpen' ? 'midOpen' : 'closed')"
                 [ngClass]="'arrow-down-container-'+showItineraryDetails()">
                    <mat-icon  class="details-arrow-down-icon">arrow_forward_ios</mat-icon>
                </div>
            </div>
            <div *ngIf="itinerarySelected()  && showItineraryDetails() !== 'closed'" class="footer-container" [ngClass]="'footer-container-'+showItineraryDetails()" >
                <app-map-results-footer #resultsDetailContainer [itinerarySelected]="itinerarySelected" [routeFormResult]="routeFormResult"></app-map-results-footer>            
            </div>
        </div>
    </ng-container>
    
</div>

<div #locateButton (click)="locateButtonClicked()" [ngClass]="mapLoaded() ? '' : 'esri-hidden'" class="esri-widget--button esri-locate esri-widget esri-locate esri-interactive" >
    <span class="esri-icon esri-icon-locate" [title]="'map.goToCurrentUbication' | transloco"></span>
</div>

<div #contextMenu class="context-menu">
    <div (click)="routeFromHereClicked()" class="context-menu-option">{{'map.calculateRouteFromThisPoint' | transloco}}</div>
    <div (click)="routeToHereClicked()" class="context-menu-option">{{'map.calculateRouteToThisPoint' | transloco}}</div>
</div>
